import { InputAdornment } from '@mui/material';
import TextInput, { TextInputProps } from '../TextInput';
import EmailIcon from '@mui/icons-material/Email';
import React from 'react';

const EmailInput = (props: TextInputProps) => {
  return (
    <TextInput
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <EmailIcon />
            </InputAdornment>
          ),
        },
      }}
      variant={'outlined'}
      label={'Email'}
      type={'email'}
      {...props}
    />
  );
};

export default EmailInput;
